import { isNonProdEnvironment } from '@ps20-frontend/utils';
import { IAppState } from '@ps20-frontend/apps/dashboard-store';
import { FeatureToggles } from '@ps20-frontend/frontend-models';
import { Feature, Role } from '@ps20/bff-models';
import { PS20Logger } from '@ps20-frontend/logging';
import { Settings } from '@ps20-frontend/shop-integration-redux';
import {
  App,
  StateWithTransientState,
  TransientStateWithRegexps,
} from '../../../frontend-models/src';

export const selectRolle = (state: StateWithTransientState): Role => state.transientState.role;

export const selectImmobilieRequestIsInProgress = (state: IAppState): boolean =>
  state.transientState.amisCRMRquestInProgress || state.transientState.vorbelegungIsInProgress;

export const selectImmobilieAuswahlErrorExists = (state: IAppState): boolean =>
  !!state.transientState.multiangebotVwgAdressValidationResult;

export const selectRequestFailed = (state: IAppState): boolean =>
  state.transientState.requestFailed;

export const selectRegexp = (state: TransientStateWithRegexps, regexpKey: string): string => {
  const defaultRegexp = '^.+$';
  const regexps = state.transientState?.regexps;
  if (!regexps) {
    PS20Logger.error(App.SHOP, 'No regexps available.');
    return defaultRegexp;
  }
  if (!regexps[regexpKey]) {
    PS20Logger.error(App.SHOP, `No regexp for key "${regexpKey}" available.`);
    return defaultRegexp;
  }

  return regexps[regexpKey];
};

export const selectFeatureToggle = (
  state: { transientState: { featureToggles: FeatureToggles } },
  toggle: Feature,
): boolean | undefined => state.transientState.featureToggles[toggle];

export const selectIsAuslandsImmobilie = (state: IAppState): boolean =>
  state.transientState?.isAuslandsImmobilie;

export const selectValueFromSettings = (
  state: { transientState: { settings?: Settings } },
  settingName: string,
): string => {
  const settingPath = settingName.split('.');
  let settingValue = state.transientState.settings[settingPath[0]];
  let pathPosition = 2;
  while (pathPosition <= settingPath.length) {
    settingValue = settingValue[settingPath[pathPosition - 1]];
    pathPosition += 1;
  }
  return settingValue;
};

export const selectPreisverzeichnisTestValue = (state: {
  transientState: { settings?: Settings };
}): number => {
  if (isNonProdEnvironment()) {
    const raw = localStorage.getItem('preisverzeichnisTestValue');
    const parsed = Number.parseInt(raw, 10);
    if (raw !== null && Number.isFinite(parsed)) {
      return parsed;
    }
  }

  return Number.parseInt(selectValueFromSettings(state, 'preisverzeichnisTestValue'), 10);
};

export const selectUnfallVpMaxAlterErsatzgeschaeft = (state: {
  transientState: { settings?: Settings };
}): number => {
  if (isNonProdEnvironment()) {
    const raw = localStorage.getItem('unfallVpMaxAlterErsatzgeschaeft');
    const parsed = Number.parseInt(raw, 10);
    if (raw !== null && Number.isFinite(parsed)) {
      return parsed;
    }
  }

  return Number.parseInt(selectValueFromSettings(state, 'unfallVpMaxAlterErsatzgeschaeft'), 10);
};

export const selectIsAzamUnderwriter = (state: IAppState): boolean =>
  state.transientState.role === Role.UWPSHRK;

export const selectIsUnderwriter = (state: IAppState): boolean => {
  return state.transientState.role === Role.GER_SDW_UW_USER || state.transientState.wasUw === true;
};
